import { Logo } from "@/components/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-line bg-[var(--surface)]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 text-sm text-muted max-w-sm leading-relaxed">
            AICS AGENT deploys autonomous AI Security Engineers that help growing companies discover,
            understand, prioritize and remediate security risks — while building continuous compliance readiness.
          </p>
          <div className="mt-5 flex items-center gap-2 text-xs text-muted font-mono">
            <span className="w-2 h-2 rounded-full bg-secure live-dot" /> All systems operational
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold text-ink text-sm mb-4">Platform</h4>
          <ul className="space-y-2.5 text-sm text-muted">
            <li><Link to="/#platform" className="hover:text-cyber">Security Modules</Link></li>
            <li><Link to="/#demo" className="hover:text-cyber">Live Demo</Link></li>
            <li><Link to="/pricing" className="hover:text-cyber">Pricing</Link></li>
            <li><Link to="/signup" className="hover:text-cyber">Start Free</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-ink text-sm mb-4">Compliance</h4>
          <ul className="space-y-2.5 text-sm text-muted">
            <li>SOC 2 Type II</li>
            <li>ISO 27001</li>
            <li>GDPR</li>
            <li>HIPAA</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line py-6 text-center text-xs text-muted">
        © {new Date().getFullYear()} AICS AGENT. Built for lean teams operating at enterprise scale.
      </div>
    </footer>
  );
}
